export default "mutation addResourceTag($add: ResourceTagAddRequest) {\n  addResourceTag(add: $add) \n}";